import { Component, Input, HostListener, Output, EventEmitter } from '@angular/core';
import {FormGroup, FormControl, AbstractControl} from '@angular/forms';

import { AreaTypeEnum } from '@commons/enums/area-type.enum';



@Component({
  selector: 'tk-area-form-input',
  styleUrls: ['./area-form-input.component.less'],
  templateUrl: './area-form-input.component.html'
})
export class AreaFormInputComponent {

  /**
   * Filter form
   */
  @Input() public control!: AbstractControl;

  /**
   * Area type enum
   */
  @Input() public areaType!: AreaTypeEnum;


  @Input() public newAreaNamePlaceHolder!: string;

  /**
   * Clears form's phrase
   */
  public onClear(): void {

    // Clear phrase and send filter request
    this.control?.setValue('');
    this.control?.markAsDirty();
  }


  /**
   *
   */
  public getAreaIconTypeClass(): any {

    return {
      'area-form-input__type-icon--polygon': this.areaType === AreaTypeEnum.Polygon,
      'area-form-input__type-icon--circle': this.areaType === AreaTypeEnum.Circle,
      'area-form-input__type-icon--line': this.areaType === AreaTypeEnum.Line
    };
  }

  public onFocusChanged() {
    this.control?.setValue('');
    this.control?.markAsDirty();
  }
}

